export default __webpack_public_path__ + "static/media/spinner-bg-tablet.ea05ab78.png";